'use strict';

const numberOfPeople = function ($filter) {
  return input => $filter('translate')('NUMBER_OF_PEOPLE.' + String(input));
};

numberOfPeople.$inject = [
  '$filter'
];

export default numberOfPeople;



// WEBPACK FOOTER //
// ./app/src/filters/number_of_people.js